import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod'

const formSchema = z.object({
  title: z.string().min(1, 'Título é obrigatório'),
  link: z.string().url('Url inválida'),
  description: z
    .string()
    .min(10, 'A descrição deve ter no mínimo 10 caracteres')
    .max(500, 'Descrição deve ter no máximo 500 caracteres'),
  file: z
    .instanceof(File)
    .nullable()
    .refine((file) => file && file.size > 0, {
      message: 'Thumbnail é obrigatória',
    }),
  icon: z.string().optional(),
  frequency: z
    .array(
      z.object({
        day: z.number(),
        hour: z.string().regex(/^[0-2][0-9]:[0-5][0-9]$/, 'Hora inválida'),
      }),
    )
    .min(1, 'Frequência é obrigatória'),
  isSellersApp: z.boolean().optional(),
  isTeamsApp: z.boolean().optional(),
})

export type LiveFormValues = z.infer<typeof formSchema>

export const initialData: LiveFormValues = {
  link: '',
  title: '',
  description: '',
  file: null,
  icon: '',
  frequency: [
    {
      day: new Date().getDay(),
      hour: '12:00',
    },
  ],
  isSellersApp: false,
  isTeamsApp: false,
}

interface UseLiveFormProps {
  getDefaultValue?: () => Promise<LiveFormValues>
}

export default function useLiveForm({ getDefaultValue }: UseLiveFormProps) {
  const form = useForm<LiveFormValues>({
    resolver: zodResolver(formSchema),
    defaultValues: async () => {
      if (getDefaultValue) {
        return await getDefaultValue()
      }

      return initialData
    },
  })

  return form
}
